import { systemConstants } from "@shared/constants/systemConstants";

export const resetActions = {
  reset
};

function reset() {
  return { type: systemConstants.logout.resetApp };
}
